package nl.astraeus.wiki.view

import kotlinx.browser.document
import kotlinx.html.div
import kotlinx.html.h1
import kotlinx.html.js.onClickFunction
import kotlinx.html.org.w3c.dom.events.Event
import nl.astraeus.css.properties.*
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.wiki.WikiData
import nl.astraeus.wiki.WikiData.currentWiki
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssName
import nl.astraeus.wiki.mainView
import nl.astraeus.wiki.messages.LogoutMessage
import nl.astraeus.wiki.service.UserService
import nl.astraeus.wiki.service.WikiService
import nl.astraeus.wiki.ws.WebsocketConnection
import org.w3c.dom.HTMLInputElement

class WikiHeader : Komponent(), CssName {
  private object TitleInputCss : CssName
  private object WikiHeaderTitleCss : CssName

  init {
    defineCss {
      select(TitleInputCss.cls()) {
        fontSize(28.px)
        border("none")
        backgroundColor(hsl(60, 50, 90))
        padding(0.5.rem)
        position(Position.relative)
        top((-0.5).rem)
      }
      select(WikiHeaderTitleCss.cls()) {
        display(Display.flex)
        flexDirection(FlexDirection.row)
        justifyContent(JustifyContent.spaceBetween)
      }
    }
  }

  var editingTitle = false

  fun titleClick(e: Event) {
    editingTitle = true
    requestUpdate()
  }

  fun titleSave(e: Event) {
    editingTitle = false
    val target = e.target

    if (target is HTMLInputElement) {
      currentWiki?.title = target.value
    }

    requestUpdate()
  }

  override fun HtmlBuilder.render() {
    div(WikiHeaderTitleCss.name) {
      h1 {
        +"List of wiki's"
      }
      if (UserService.loggedIn) {
        div("${MainView.AddCss.name} ${MainView.HeaderButtonCss.name}") {
          +"Logout ${UserService.currentUser?.name ?: "user"}"

          onClickFunction = {
            WebsocketConnection.send(
              LogoutMessage()
            ) { msg ->
              WikiData.clear()
              UserService.currentUser = null
              WikiService.retrieveWikiList()

              mainView.requestUpdate()
            }
          }
        }
      } else {
        div("${MainView.AddCss.name} ${MainView.HeaderButtonCss.name}") {
          +"Login"

          onClickFunction = {
            create(
              document.body!!,
              Login()
            )
          }
        }
      }
    }
  }
}
